// Temporary front fake data for the "Recharges électriques" table, mocking the
// future backend endpoint that merges CasaWatt (home) charges with our EMSP CDRs
// (station / on-site) and card charges. Only authorized charges are returned.
// Replace with the real endpoint once the back is wired.

import { ElectricCharge } from "./electricChargingAPI";

export const fakeElectricCharges: ElectricCharge[] = [
  {
    uuid: "e1000000-0000-4000-8000-000000000001",
    type: "STATION",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    startAt: "2026-02-28T15:39:00.000Z",
    stopAt: "2026-02-28T17:56:00.000Z",
    locationCity: "Crèches-sur-Saône",
    totalCost: 13.91,
    totalTime: 137,
    totalEnergy: 54.3,
    chargingTime: 137,
    totalParkingTime: 0,
  },
  {
    uuid: "e1000000-0000-4000-8000-000000000002",
    type: "HOME",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    startAt: "2026-02-28T21:05:00.000Z",
    stopAt: "2026-02-28T23:22:00.000Z",
    locationCity: "Crèches-sur-Saône",
    totalCost: 11.12,
    totalTime: 137,
    totalEnergy: 54.3,
    chargingTime: 137,
    totalParkingTime: 0,
  },
  {
    uuid: "e1000000-0000-4000-8000-000000000003",
    type: "ON_SITE",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    startAt: "2026-02-27T08:10:00.000Z",
    stopAt: "2026-02-27T10:27:00.000Z",
    locationCity: "Crèches-sur-Saône",
    totalCost: 13.91,
    totalTime: 137,
    totalEnergy: 54.3,
    chargingTime: 137,
    totalParkingTime: 0,
  },
  {
    uuid: "e1000000-0000-4000-8000-000000000004",
    type: "HOME",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    startAt: "2026-02-26T20:40:00.000Z",
    stopAt: "2026-02-26T22:10:00.000Z",
    locationCity: "Mâcon",
    totalCost: 8.24,
    totalTime: 90,
    totalEnergy: 32.1,
    chargingTime: 90,
    totalParkingTime: 0,
  },
  {
    uuid: "e1000000-0000-4000-8000-000000000005",
    type: "STATION",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    startAt: "2026-02-25T12:15:00.000Z",
    stopAt: "2026-02-25T13:05:00.000Z",
    locationCity: "Lyon",
    totalCost: 6.4,
    totalTime: 50,
    totalEnergy: 22.7,
    chargingTime: 50,
    totalParkingTime: 0,
  },
  {
    uuid: "e1000000-0000-4000-8000-000000000006",
    type: "ON_SITE",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    startAt: "2026-02-24T18:30:00.000Z",
    stopAt: "2026-02-24T20:20:00.000Z",
    locationCity: "Crèches-sur-Saône",
    totalCost: 10.8,
    totalTime: 110,
    totalEnergy: 41.5,
    chargingTime: 110,
    totalParkingTime: 0,
  },
  {
    uuid: "e1000000-0000-4000-8000-000000000007",
    type: "HOME",
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: null,
    startAt: "2026-02-23T19:15:00.000Z",
    stopAt: "2026-02-23T21:30:00.000Z",
    locationCity: "Mâcon",
    totalCost: 9.5,
    totalTime: 135,
    totalEnergy: 38.2,
    chargingTime: 135,
    totalParkingTime: 0,
  },
  {
    uuid: "e1000000-0000-4000-8000-000000000008",
    type: "STATION",
    registrationNumber: "ST-456-UV",
    identifier: "BADGE-77821",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    startAt: "2026-02-22T09:00:00.000Z",
    stopAt: "2026-02-22T10:12:00.000Z",
    locationCity: "Villefranche-sur-Saône",
    totalCost: 7.3,
    totalTime: 72,
    totalEnergy: 25.6,
    chargingTime: 72,
    totalParkingTime: 0,
  },
  {
    uuid: "e1000000-0000-4000-8000-000000000009",
    type: null,
    registrationNumber: "ST-456-UV",
    identifier: "",
    vehicleReference: "TEAM 890 -4",
    driverName: "Aude Bousquet",
    startAt: "2026-02-21T07:30:00.000Z",
    stopAt: "2026-02-21T08:20:00.000Z",
    locationCity: "Chalon-sur-Saône",
    totalCost: 5.9,
    totalTime: 50,
    totalEnergy: 19.8,
    chargingTime: 50,
    totalParkingTime: 0,
  },
];
